var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"c-chat__lastMessagesButton c-button -primary t-button1",on:{"click":_setup.scrollToLastMessage}},[_c('SvgIcon',{attrs:{"small":"","type":"chat_arrow_down"}}),_c('span',[_vm._v(_vm._s(_vm.$t('chat.last_messages', { count: _setup.chatThreadStore?.unSeenMessages })))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }